<template xmlns="http://www.w3.org/1999/html">
  <div class="main-content">


    <img src="/static/images/zmn/logo.png" style="width: 100vw;" />

    <div class="section-title">扫描识别产品唯一码</div>

    <div class="scanner-section">

      <div class="scanner-frame">
        <div class="scanner-corners" @click="toScan()">
          <div class="corner top-left"></div>
          <div class="corner top-right"></div>
          <div class="corner bottom-left"></div>
          <div class="corner bottom-right"></div>
        </div>
        <div class="scanner-icon">
          <span class="material-icons" style="font-size: inherit;">qr_code_scanner</span>
        </div>
        <div class="scan-line"></div>
      </div>
    </div>

    <div class="section-title">或手动输入序列号查询</div>

    <div class="input-container">
      <input v-model="antiCode" type="number" class="input-field" placeholder="请输入16位防伪码查询" maxlength="16">
    </div>

    <button class="query-btn" @click="handleQuery">查询</button>
    <div class="help-text">
      输入产品包装上的防伪码进行真伪验证
    </div>
  </div>
</template>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #212529;
}


.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fafafa;
  justify-content: space-between;
}

.scanner-section {
  margin-bottom: 2vh;
  margin-top: 3vh;
  text-align: center;
  width: 100%;
}

.section-title {
  font-size: 4vw;
  margin-top: 3vh;
  margin-bottom: 1vh;
  color: #666;
  font-weight: 400;
  line-height: 1.4;
}

.scanner-frame {
  width: 40vw;
  height: 40vw;
  border: 3px solid #4285f4;
  border-radius: 16px;
  position: relative;
  margin: 0 auto;
  background: linear-gradient(135deg, rgba(66, 133, 244, 0.1) 0%, rgba(66, 133, 244, 0.05) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.scanner-corners {
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
}

.corner {
  position: absolute;
  width: 30px;
  height: 30px;
  border: 4px solid #4285f4;
}

.corner.top-left {
  top: 0;
  left: 0;
  border-right: none;
  border-bottom: none;
  border-top-left-radius: 16px;
}

.corner.top-right {
  top: 0;
  right: 0;
  border-left: none;
  border-bottom: none;
  border-top-right-radius: 16px;
}

.corner.bottom-left {
  bottom: 0;
  left: 0;
  border-right: none;
  border-top: none;
  border-bottom-left-radius: 16px;
}

.corner.bottom-right {
  bottom: 0;
  right: 0;
  border-left: none;
  border-top: none;
  border-bottom-right-radius: 16px;
}

.scan-line {
  width: 80%;
  height: 3px;
  background: linear-gradient(90deg, transparent, #4285f4, transparent);
  animation: scan 2s ease-in-out infinite;
}

@keyframes scan {

  0%,
  100% {
    transform: translateY(-80px);
    opacity: 0;
  }

  50% {
    transform: translateY(0);
    opacity: 1;
  }
}

.scanner-icon {
  position: absolute;
  font-size: 60px;
  color: rgba(66, 133, 244, 0.3);
  z-index: -1;
}

.input-section {
  width: 100%;
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 320px;
}

.divider-text {
  font-size: 15px;
  color: #666;
  margin-bottom: 24px;
  font-weight: 400;
  line-height: 1.4;
  font-family: 'Alibaba PuHuiTi', sans-serif;
}

.input-container {
  margin-top: 1vh;
  margin-bottom: 3vh;
}

.input-field {
  text-align: center;
  width: 80vw;
  height: 6.5vh;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 4vw;
  color: #1a1a1a;
  background: white;
  transition: all 0.3s ease;
  outline: none;
}

.input-field:focus {
  border-color: #4285f4;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
}

.input-field::placeholder {
  color: #999;
  font-size: 16px;
  font-family: 'Alibaba PuHuiTi', sans-serif;
}

.query-btn {
  width: 80vw;
  height: 6.5vh;
  background: linear-gradient(135deg, #1976d2, #4285f4);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(66, 133, 244, 0.3);
  font-family: 'Alibaba PuHuiTi', sans-serif;
}

.query-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(66, 133, 244, 0.4);
}

.query-btn:active {
  transform: translateY(0);
}

.help-text {
  margin-top: 16px;
  font-size: 13px;
  color: #999;
  text-align: center;
  line-height: 1.5;
  padding: 0 8px;
  font-family: 'Alibaba PuHuiTi', sans-serif;
}

/* 响应式调整 */
@media (max-width: 400px) {
  .phone-frame {
    width: 100%;
    max-width: 375px;
    height: 100vh;
    border-radius: 0;
  }
}

/* 涟漪效果 */
.ripple {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  transform: scale(0);
  animation: ripple-animation 0.6s linear;
  pointer-events: none;
}

@keyframes ripple-animation {
  to {
    transform: scale(4);
    opacity: 0;
  }
}

.query-btn {
  position: relative;
  overflow: hidden;
}
</style>

<script>
import { getAntiData, getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      antiCode: "",
      eno: "138251972252",
    }
  },
  mounted: function () {
    this.getWxJs()
  },
  methods: {
    handleQuery() {
      if(this.antiCode=="" ||this.antiCode.length!=16){
        alert("请输入16位防伪码进行查询验证")
      }else{
        this.queryAnti()
      }
    },
    toScan() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('?');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }else{
            scanQRCode = scanQRCode.replaceAll('CODE_128,','')
          }
          this.antiCode=scanQRCode
          this.queryAnti()
        }
      });
    },
    queryAnti(){
      this.$router.replace({
        path: '/zmn',
        query: {
          c: this.antiCode,
          eno: this.eno
        }
      })
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx885161c495be58a3").then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        console.log(err)
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ZhuoMuNiao/Query.vue